module.exports = __webpack_public_path__ + "static/media/traf.05bf71ba.png";